export const CANVAS_STYLE = {
  width: '100%',
  height: '70px',
};

export const SILENCE_VOLUME_THRESHOLD = 200.0;
export const SILENCE_PERIOD_THRESHOLD = 10;

export const permissionErrKeyword = 'No permission';
export const canAccessAgentResourceErrKeyword = 'Not Authorized';
export const CSOSErrKeyword = 'CSOS';
export const missingContactData = 'Missing contact data';
